// extracted by mini-css-extract-plugin
export default {"table":"authors-table_table__mjwgI"};